import { useArenaTournaments } from 'modules/arena/tournaments/useArenaTournaments';
import { StatTile } from 'shared/components/ui/StatTile';
import { TournamentRow } from 'modules/arena/tournaments/components/TournamentRow';
import { TournamentDetailPanel } from 'modules/arena/tournaments/components/TournamentDetailPanel';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { SkeletonListDetail, SkeletonStatGrid } from 'shared/components/ui/Skeleton';

export function ArenaTournamentsPage() {
  const {
    tournaments,
    isLoading,
    error,
    selectedId,
    setSelectedId,
    selectedTournament,
    confirmRegistration,
    cancelRegistration,
    promoteFromWaitlist,
    publishTournament,
    closeTournament,
  } = useArenaTournaments();

  const publishedCount = tournaments.filter((t) => t.status === 'publicado').length;
  const totalRegistered = tournaments.reduce(
    (sum, t) =>
      sum +
      t.categories.reduce(
        (catSum, category) => catSum + category.registrations.filter((r) => r.status !== 'cancelada').length,
        0
      ),
    0
  );
  const totalCapacity = tournaments.reduce(
    (sum, t) => sum + t.categories.reduce((catSum, category) => catSum + category.capacity, 0),
    0
  );
  const totalWaitlist = tournaments.reduce(
    (sum, t) => sum + t.categories.reduce((catSum, category) => catSum + category.waitlist.length, 0),
    0
  );

  return (
    <div className="flex-1 p-6">
      <h1 className="font-heading text-xl font-bold text-ink">Torneios</h1>
      <p className="text-sm text-ink-secondary">
        Categorias, inscrições, pagamento e lista de espera dos torneios da unidade.
      </p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando torneios..."
        skeleton={
          <>
            <SkeletonStatGrid />
            <SkeletonListDetail rows={3} lines={3} columns="lg:grid-cols-[1fr_1.2fr]" className="mt-6" />
          </>
        }
      >
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatTile label="Torneios publicados" value={String(publishedCount)} />
            <StatTile label="Duplas inscritas" value={`${totalRegistered}/${totalCapacity}`} />
            <StatTile label="Na lista de espera" value={String(totalWaitlist)} />
            <StatTile label="Torneios cadastrados" value={String(tournaments.length)} />
          </div>

          <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_1.2fr]">
            <div className="flex flex-col gap-3">
              {tournaments.map((tournament) => (
                <TournamentRow
                  key={tournament.id}
                  tournament={tournament}
                  isSelected={tournament.id === selectedId}
                  onSelect={setSelectedId}
                />
              ))}
            </div>

            <div className="lg:sticky lg:top-6 lg:self-start">
              {selectedTournament ? (
                <TournamentDetailPanel
                  tournament={selectedTournament}
                  onConfirmRegistration={confirmRegistration}
                  onCancelRegistration={cancelRegistration}
                  onPromoteFromWaitlist={promoteFromWaitlist}
                  onPublish={publishTournament}
                  onClose={closeTournament}
                />
              ) : (
                <p className="text-sm text-ink-secondary">Selecione um torneio para ver os detalhes.</p>
              )}
            </div>
          </div>
      </AsyncSection>
    </div>
  );
}
